import "./dashboard-sections.css";
import DashboardCard from "./DashboardCard";

const EvapBox = ({ label, value, unit }) => (
  <div className="db-evap-box">
    <div className="db-evap-label">{label}</div>
    <div className="db-evap-value neutral">
      {value ?? "—"}{unit && <span className="db-metric-unit"> {unit}</span>}
    </div>
  </div>
);

const RunningTotalsExtra = ({ data = {}, isLoading = false }) => {
  const d = data;

  const prcsMetrics  = data?.processing_metrics ?? [];

  const packingMetrics = data?.packing_analytics ?? [];


  return (
    <div className="rte-wrapper">

      {/* Processing */}
      <DashboardCard title="Processing">
        <div className="db-evap-row">
          <EvapBox label="TOTAL ACCEPTED KG"      value={prcsMetrics?.total_accepted_in_processing} unit="kg" />
          <EvapBox label="TOTAL CASES PROCESSED"  value={prcsMetrics?.total_cases_processed} />
          <EvapBox label="GAS LITERS"   value={prcsMetrics?.total_gas_consumed_ltr} unit="L" />
          <EvapBox label="GAS COSTING"  value={prcsMetrics?.total_gas_cost ? `$${prcsMetrics.total_gas_cost}` : "0"} />
        </div>
      </DashboardCard>

      {/* Packing */}
      <DashboardCard title="Packing">
        <div className="db-evap-row">
          <EvapBox label="PRIME CHEEKS PACKED"       value={packingMetrics?.prime_cheeks_packed_kg}       unit="kg" />
          <EvapBox label="PRIME STRIPS PACKED"       value={packingMetrics?.prime_strips_packed_kg}       unit="kg" />
          <EvapBox label="TOTAL BOXES PACKED PRIME"  value={packingMetrics?.total_prime_packed_boxes}            />
        </div>
        <div className="db-evap-row" style={{ borderTop: "1px solid #f0f1f3", paddingTop: 12 }}>
          <EvapBox label="BROKERING KG PRIME"        value={packingMetrics?.total_prime_kg_from_brokerage}        unit="kg" />
          <EvapBox label="BROKERING 2ND & PIECES"    value={`${packingMetrics?.total_second_kg_from_brokerage} & ${packingMetrics?.total_pieces_kg_from_brokerage}`}          unit="kg" />
          <EvapBox label="PASTING BOXES (BROK+PACK)" value={packingMetrics?.total_pasted_boxes_packed}                 />
        </div>
      </DashboardCard>
    </div>
  );
};

export default RunningTotalsExtra;
